import React from 'react'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { receivingLogout } from '../../services/receiving'
import './receiving.css'

export const receivingUser = () => {
  try { return JSON.parse(localStorage.getItem('receivingUser') || 'null') } catch { return null }
}

export const addMonthsNoOverflow = (dateString, months = 5) => {
  const [year, month, day] = dateString.split('-').map(Number)
  const targetStart = new Date(year, month - 1 + months, 1)
  const lastDay = new Date(targetStart.getFullYear(), targetStart.getMonth() + 1, 0).getDate()
  const date = new Date(targetStart.getFullYear(), targetStart.getMonth(), Math.min(day, lastDay))
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export const resolveTrackingPullOutDate = (receivedDate, activePullOutDate) =>
  activePullOutDate || addMonthsNoOverflow(receivedDate)

// Retained temporarily for older imports while receiving moves from
// customer-scoped storage periods to tracking-number-scoped periods.
export const resolveCustomerPullOutDate = resolveTrackingPullOutDate

export default function ReceivingLayout({ children, title, showLogout = true }) {
  const navigate = useNavigate()
  const user = receivingUser()
  const logout = async () => {
    try { await receivingLogout() } catch (_) {}
    localStorage.removeItem('receivingToken'); localStorage.removeItem('receivingUser')
    navigate('/receiving/login', { replace: true })
  }
  return <div className="receiving-app">
    <header className="receiving-header">
      <div className="receiving-header-inner">
        <div className="receiving-header-copy"><span className="receiving-eyebrow">AIMS OPERATIONS</span><h1>{title}</h1>{user && <p>{user.name} · {user.type}</p>}</div>
        {showLogout && <Button variant="outlined" color="inherit" onClick={logout}>Sign out</Button>}
      </div>
    </header>
    <main className="receiving-main">{children}</main>
  </div>
}
